"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const util_1 = require("../components/three/util");
exports.initialCube = (colour, scale) => {
    //Cube with base on y = 0, centred around (0,0,0), of size scale
    const t1 = new THREE.Vector3(0.5, 0.5, -0.5).multiplyScalar(scale);
    const t2 = new THREE.Vector3(-0.5, 0.5, -0.5).multiplyScalar(scale);
    const t3 = new THREE.Vector3(-0.5, 0.5, 0.5).multiplyScalar(scale);
    const t4 = new THREE.Vector3(0.5, 0.5, 0.5).multiplyScalar(scale);
    const b1 = new THREE.Vector3(-0.5, -0.5, 0.5).multiplyScalar(scale);
    const b2 = new THREE.Vector3(-0.5, -0.5, -0.5).multiplyScalar(scale);
    const b3 = new THREE.Vector3(0.5, -0.5, -0.5).multiplyScalar(scale);
    const b4 = new THREE.Vector3(0.5, -0.5, 0.5).multiplyScalar(scale);
    return [
        //Top
        { vertices: [t1, t2, t3, t4], normal: new THREE.Vector3(0, 1, 0), colour },
        //Front
        { vertices: [b1, b4, t4, t3], normal: new THREE.Vector3(0, 0, 1), colour },
        //Right
        { vertices: [b4, b3, t1, t4], normal: new THREE.Vector3(1, 0, 0), colour },
        //Back
        { vertices: [b3, b2, t2, t1], normal: new THREE.Vector3(0, 0, -1), colour },
        //Left
        { vertices: [t3, t2, b2, b1], normal: new THREE.Vector3(-1, 0, 0), colour },
        //Bottom
        { vertices: [b1, b2, b3, b4], normal: new THREE.Vector3(0, -1, 0), colour }
    ];
};
exports.initialTetra = (colour, scale) => {
    const theta = Math.PI / 3.0;
    const top = new THREE.Vector3(0, 1, 0).multiplyScalar(scale);
    const right = new THREE.Vector3(1, 0, 0).multiplyScalar(scale);
    const rear = new THREE.Vector3(-Math.cos(theta), 0, Math.sin(theta)).multiplyScalar(scale);
    const forward = new THREE.Vector3(-Math.cos(theta), 0, -Math.sin(theta)).multiplyScalar(scale);
    return [
        //Front:
        { vertices: [top, right, forward], colour: colour },
        //Back:
        { vertices: [top, rear, right], colour: colour },
        //Left:
        { vertices: [top, forward, rear], colour: colour },
        //Bottom:
        { vertices: [forward, right, rear], colour: colour }
    ].map(el => ({
        vertices: el.vertices,
        colour: el.colour,
        normal: util_1.calcNormal(el.vertices)
    }));
};
exports.initialSquare = (colour, scale) => {
    //Square with base on y = 0, centred around (0,0.2,0), of size 0.1
    const t1 = new THREE.Vector3(0.5, 0.0, -0.5).multiplyScalar(scale);
    const t2 = new THREE.Vector3(-0.5, 0.0, -0.5).multiplyScalar(scale);
    const t3 = new THREE.Vector3(-0.5, 0.0, 0.5).multiplyScalar(scale);
    const t4 = new THREE.Vector3(0.5, 0.0, 0.5).multiplyScalar(scale);
    return [
        //Top
        {
            vertices: [t1, t2, t3, t4],
            normal: new THREE.Vector3(0, 1, 0),
            colour: colour
        },
        //Bottom
        {
            vertices: [t4, t3, t2, t1],
            normal: new THREE.Vector3(0, -1, 0),
            colour: colour
        }
    ];
};



// WEBPACK FOOTER //
// ./src/data/initialFaces.ts